import { render } from "./HomeV2WhyChooseDespensaryCMSFaq.vue?vue&type=template&id=40080ed7&scoped=true"
import script from "../js/why-choose-despensary.js?vue&type=script&lang=js"
export * from "../js/why-choose-despensary.js?vue&type=script&lang=js"

import "./HomeV2WhyChooseDespensaryCMSFaq.vue?vue&type=style&index=0&id=40080ed7&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40080ed7"]])

export default __exports__